'use strict';

class ConferenceStatusView {

    constructor(params) {

        this.maximumNumberOfUser = 3;
        this.plane = undefined;
        this.speakerImageLocation = "images/conferenceSpeaker.png";
        this.speakerImage = new Picture2D.Image(this.speakerImageLocation);

        this.font = `${Math.floor(params.dimension.height / 8)}px ${global_font_family}`;

        this.ConferenceViewColor = {
            textColor: "#ffffff"
        };
    }

    async createCanvas(params) {
        try {
            this.width = params.dimension.width;
            this.height = params.dimension.height;
            this.location = params.location;
            this.dimension = params.dimension;
            this.userDetails = params.userDetails;

            this.userDetails.reverse();

            if (this.plane) {
                this.populateContainer(this.container, this.userDetails);
                await this.picture.paint();
                this.plane.material.map.needsUpdate = true;

            } else {
                this.dispose();
                this.container = new Picture2D.Grid(3, 3, 1);
                this.populateContainer(this.container, this.userDetails);

                this.picture = new Picture2D.Picture(this.container, this.width, this.height);
                await this.picture.paintAsync();

                const texture = new THREE.CanvasTexture(this.picture.canvas);
                texture.colorSpace = THREE.SRGBColorSpace;
                texture.needsUpdate = true;

                this.plane = new THREE.Mesh(new THREE.PlaneGeometry(1, 1), new THREE.MeshBasicMaterial({
                    map: texture,
                    transparent: true,
                    opacity: 0.99
                }));

                this.plane.renderOrder = RenderOrderEnum.VRMessageRO;
                iq3Camera.camera.add(this.plane);

                this.setLocation(this.location, this.dimension);

                this.resizeListener = () => {
                    this.setLocation(this.location, this.dimension);
                };

                window.addEventListener('resize', this.resizeListener);
            }
        } catch (ex) {
            this.dispose();
            console.log("Canvas creating error : " + ex);
        }
    }

    populateContainer(container, userDetails) {
        container.clearAllElements();

        for (let i = 0; i < Math.min(this.maximumNumberOfUser, userDetails.length); i++) {

            if (!userDetails[i] || !wv.effectController.Participants[userDetails[i].id.toString()]) {
                continue;
            }

            const userName = userDetails[i].name;
            const imagePath = userDetails[i].imagePath;

            const profileImage = new Picture2D.Image(imagePath);
            const userNameText = new Picture2D.Text(userName, this.font, this.ConferenceViewColor.textColor);

            container.addElement(profileImage, i, 0, 1, 1, 1);
            container.addElement(userNameText, i, 1, 1, 1, 1);
            container.addElement(this.speakerImage, i, 2, 1, 1, 1);
        }
    }

    setLocation(location, dimension) {
        this.location = location;
        this.dimension = dimension;

        const {scale, position} = mapScreenDimensionTo3D(location, dimension);

        if (this.plane) {
            this.plane.scale.copy(scale);
            this.plane.position.copy(position);
        }
    }

    dispose() {
        window.removeEventListener('resize', this.resizeListener);
        iq3Camera.camera.remove(this.plane);
        disposeObject(this.plane);
        this.plane = undefined;
    }
}

export default ConferenceStatusView;
